"use client";

import { RunDetails } from "@/components/RunDetails";
import { useDashboardRouter as useRouter } from "@/hooks/useDashboardRouter";

export default function OrgWorkflowRunSummary() {
  const router = useRouter();
  const { runId, attempt } = router.query;

  return runId && typeof runId === "string" ? (
    <RunDetails
      runId={runId}
      initialAttempt={attempt ? Number(attempt) : undefined}
      updateBrowserTitle={true}
    />
  ) : (
    <div className="p-6">Loading...</div>
  );
}
